<template>
  <div class="payments-editor-roadmap">
    <div class="payments-editor-roadmap__select">
      <row :gutter="16">
        <i-col span="24">
          <span class="ms-help label">Включенные в платеж этапы</span>
          <i-select
            v-model="stages"
            size="default"
            multiple
            placeholder="Выберите этапы"
            :max-tag-count="1"
            @on-change="changeStages"
            :disabled="
              !getContractModulePerms('contract_payments', 'update') ||
              payment.type_id !== 2
            "
          >
            <i-option
              v-for="stage in roadmap"
              :value="stage.id"
              :label="stage.name"
              :key="stage.id"
              :disabled="
                stage.prepaid_value - stage.prepaid_payments_value === 0
              "
            >
              <div class="payments-editor-act__option">
                <span
                  class="payments-editor-act__option-text ms-text ms-ellipsis"
                  >{{ stage.name }}</span
                >
                <span class="payments-editor-act__option-debt ms-help">
                  (не выплачено
                  {{
                    getFormattedCosts(
                      stage.prepaid_value - stage.prepaid_payments_value,
                      true
                    )
                  }})
                </span>
              </div>
            </i-option>
          </i-select>
        </i-col>
      </row>
    </div>
    <div
      class="payments-editor-roadmap__stages-stat"
      v-if="filteredRoadmaps.length"
    >
      <div class="ms-help label">
        Укажите сумму по каждому из этапов
      </div>
      <card dis-hover :padding="8">
        <ul class="payments-editor-roadmap__stages-list">
          <li
            class="payments-editor-roadmap__stages-item"
            v-for="item in filteredRoadmaps"
            :key="item.id"
          >
            <div class="payments-editor-roadmap__stages-info">
              <div class="payments-editor-roadmap__stages-name ms-small-head">
                {{ item.name }}
              </div>
              <div class="payments-editor-roadmap__stages-subinfo ms-help">
                {{ formatDefaultDate(item.roadmap_start_date) }} -
                {{ formatDefaultDate(item.roadmap_end_date) }}. Доступная сумма:
                {{
                  getFormattedCosts(
                    getRoadmapMaxValue(item),
                    false,
                    withVat
                  )
                }}
              </div>
            </div>
            <div class="payments-editor-roadmap__stages-cost">
              <input-number
                v-model="item.value"
                :min="0"
                :max="getRoadmapMaxValue(item)"
                :formatter="costsFormatter"
                :parser="costsParser"
                size="default"
                @on-change="changeCosts"
                :disabled="
                  !getContractModulePerms('contract_payments', 'update')
                "
              />
            </div>
          </li>
        </ul>
      </card>
    </div>
  </div>
</template>

<script>
import {
  costsFormatter,
  costsParser,
  getFormattedCosts,
  formatDefaultDate,
  round
} from '@/utils'

export default {
  props: ['acts', 'roadmap', 'payment', 'payment-modal', 'current-max-value'],
  data () {
    return {
      stages: []
    }
  },
  watch: {
    '$props.paymentModal' () {
      this.stages = this.payment.roadmap_payments.map((r) => r.roadmap_id)
    },
    'payment.act_id' (act_id) {
      if (!act_id) {
        this.stages = []

        return
      }

      const act = this.acts.find(a => a.id === act_id)
      const { act_roadmaps } = act

      this.stages = act_roadmaps.map(a => a.roadmap_id)
    }
  },
  computed: {
    withVat () {
      return this.$store.state.contracts.current.with_vat
    },
    initialRoadmaps () {
      return this.roadmap.filter((r) => r.cost_lag)
    },
    filteredRoadmaps () {
      return this.payment.roadmap_payments.filter((r) => !r.disabled)
    }
  },
  methods: {
    changeStages (values) {
      const { roadmap_payments } = this.payment
      const current = roadmap_payments
        .filter((r) => !r.disabled)
        .map((r) => r.roadmap_id)

      const added = values.filter((id) => !current.includes(id))
      const removed = current.filter((id) => !values.includes(id))

      if (added.length) {
        added.forEach(newId => {
          const stage = this.roadmap.find((r) => r.id === newId)
          const addedObject = roadmap_payments.find(
            (r) => r.roadmap_id === newId
          )

          if (addedObject) {
            this.$set(addedObject, 'disabled', false)
          } else {
            this.payment.roadmap_payments.push({
              roadmap_id: newId,
              value: 0,
              ...stage,
              id: undefined
            })
          }
        })
      }

      if (removed.length) {
        const [removedId] = removed
        const removedObject = roadmap_payments.find(
          (r) => r.roadmap_id === removedId
        )

        if (removedObject.id) {
          this.$set(removedObject, 'disabled', true)
        } else {
          this.payment.roadmap_payments.splice(
            this.payment.roadmap_payments.indexOf(removedObject),
            1
          )
        }
      }
    },
    changeCosts () {
      const { roadmap_payments } = this.payment
      const activeRoadmaps = roadmap_payments.filter((r) => !r.disabled)
      const costs = activeRoadmaps.reduce((prev, el) => prev + el.value, 0)

      this.$set(this.payment, 'value', round(costs, 2))
    },
    getRoadmapMaxValue (current) {
      const { prepaid_value, prepaid_payments_value } = current
      const { type_id } = this.payment

      if (type_id === 2) {
        return prepaid_value - prepaid_payments_value
      }

      const otherRoadmaps = this.filteredRoadmaps.filter(item => item !== current)
      const otherCosts = otherRoadmaps.reduce((prev, el) => prev + el.value, 0)

      return this.currentMaxValue - otherCosts
    },
    costsFormatter,
    costsParser,
    getFormattedCosts,
    formatDefaultDate
  },
  created () {
    this.stages = this.payment.roadmap_payments.map((r) => r.roadmap_id)
  }
}
</script>

<style lang="less">
.payments-editor-roadmap {
  margin-top: 8px;

  &__select {
    margin-bottom: 8px;

    .ivu-select {
      width: 100%;

      .ivu-tag {
        max-width: 720px;
      }
    }

    &-info {
      margin: 4px 0;

      .ms-text,
      .ms-help {
        font-size: 11px;
      }
    }
  }

  &__option {
    margin-left: 8px;
    font-size: 11px;
  }

  &__stages-list {
    list-style-type: none;
  }

  &__stages-item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:first-child) {
      margin-top: 8px;
    }

    .ivu-input-number {
      width: 120px;
    }
  }

  &__stages-stat {
    margin-top: 12px;
  }

  &__stages-subinfo {
    font-size: 11px;
  }

  &__stages-cost {
    margin-left: 16px;
    flex-shrink: 0;
  }
}
</style>
